import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import FleetAdminDriverContainer from '../../component/smart/menuComponentsContainer/FleetAdminDriverContainer'
import DriversContainer from './DriversContainer'
import './Drivers.sass'

const ManageDriversPage = ({ company, user, location }) => {
	return <DriversContainer location={location} isUsingDriverFaceID={company.driver_recognition === "faceid"} />
	// const isUsingDriverFaceID = ['system_admin', 'fleet_manager'].includes(user.roles[0]) && company.driver_recognition === "faceid";

	// return (
	// 	company.driver_recognition === 'faceid' && !isUsingDriverFaceID
	// 		? <FleetAdminDriverContainer />
	// 		: <DriversContainer location={location} isUsingDriverFaceID={isUsingDriverFaceID} />
	// )
};

ManageDriversPage.propTypes = {
	company: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(
	state => ({
		company: state.company.company,
		user: state.user.user
	})
)(ManageDriversPage);
